import { useState } from 'react';
import { Box, Button, Icons, Stack, Tooltip } from '@/theme/index';
import { StyledButton } from './styledComponents';

type DebugMenuProps = {
  menuItems?: { title: string; url: string }[];
};

export const DebugMenu = ({ menuItems }: DebugMenuProps) => {
  const [open, setOpen] = useState(true);
  if (!menuItems) return null;
  const handleClick = () => {
    setOpen(true);
  };
  const handleMenuItemClick = ({ link }: { link: string }) => {
    window.open(link, '_blank');
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: open ? 0 : '5%',
        right: 0,
        backgroundColor: 'primary.dark',
        opacity: 0.9,
      }}
    >
      {open ? (
        <Stack spacing={1} sx={{ padding: 2 }} alignItems="flex-end">
          <Button
            aria-label="Close"
            onClick={handleClose}
            sx={{ padding: 0, minWidth: 'unset' }}
          >
            <Icons.Close
              sx={{
                fontSize: '1.25rem',
                color: 'primary.contrastText',
                ':hover': {
                  color: 'primary.light',
                },
              }}
            />
          </Button>
          {menuItems.map((item) => (
            <StyledButton
              key={item.title}
              onClick={() => handleMenuItemClick({ link: item.url })}
            >
              {item.title}
            </StyledButton>
          ))}
        </Stack>
      ) : (
        <Tooltip title="Open Debug Menu">
          <Button
            aria-label="Open Debug Menu"
            onClick={handleClick}
            sx={{ minWidth: 'unset', padding: 0 }}
          >
            <Icons.ChevronLeft
              sx={{
                fontSize: '2.5rem',
                fontWeight: 'bold',
                color: 'primary.contrastText',
              }}
            />
          </Button>
        </Tooltip>
      )}
    </Box>
  );
};
